import Temporal from "@/shared/ts/temporal";
import Lifestyle from "./lifestyle";

class IncomeCalculator {
  private baseIncomeAmounts = {};
  public baseDate = new Date(2023, 0, 1, 0, 0, 0, 0);

  constructor() {
    this.configureBaseIncomeAmounts();
  }

  public getBaseAmount(
    livesInLondon: boolean,
    supportingPartner: boolean,
    lifestyle: Lifestyle
  ) {
    const key = this.getKey(livesInLondon, supportingPartner, lifestyle);
    return this.baseIncomeAmounts[key];
  }

  public calcSuggestedRetirementIncome(
    livesInLondon: boolean,
    supportingPartner: boolean,
    lifestyle: Lifestyle,
    targetRetirementDate: Date
  ): number {
    const baseAmount = this.getBaseAmount(
      livesInLondon,
      supportingPartner,
      lifestyle
    );
    const adjustedAmount =
      Math.round(this.applyInflation(baseAmount, targetRetirementDate) / 100) *
      100;
    return adjustedAmount;
  }

  private applyInflation(value: number, targetRetirementDate: Date): number {
    const yearTillRetirement = Temporal.yearsBetweenDates(
      this.baseDate,
      targetRetirementDate
    );
    const inflationRate = 2.5;
    const inflationIncreaseRate = 1 + inflationRate / 100;
    return value * Math.pow(inflationIncreaseRate, yearTillRetirement);
  }

  private getKey(
    livesInLondon: boolean,
    supportingPartner: boolean,
    lifestyle: Lifestyle
  ): string {
    const getKeyFromBoolean = (boolValue: boolean): string =>
      boolValue ? "Y" : "N";
    const livesInLondonKey = getKeyFromBoolean(livesInLondon);
    const supportingPartnerKey = getKeyFromBoolean(supportingPartner);
    let lifestyleKey = "";
    switch (lifestyle) {
      case Lifestyle.Minimum:
        lifestyleKey = "MI";
        break;
      case Lifestyle.Moderate:
        lifestyleKey = "MO";
        break;
      case Lifestyle.Comfortable:
        lifestyleKey = "CO";
        break;
    }
    return `${livesInLondonKey}${supportingPartnerKey}${lifestyleKey}`;
  }

  private configureBaseIncomeAmounts() {
    this.baseIncomeAmounts["NNMI"] = 14400;
    this.baseIncomeAmounts["NNMO"] = 31300;
    this.baseIncomeAmounts["NNCO"] = 43100;
    this.baseIncomeAmounts["YNMI"] = 15700;
    this.baseIncomeAmounts["YNMO"] = 32800;
    this.baseIncomeAmounts["YNCO"] = 45000;
    this.baseIncomeAmounts["NYMI"] = 22400;
    this.baseIncomeAmounts["NYMO"] = 43100;
    this.baseIncomeAmounts["NYCO"] = 59000;
    this.baseIncomeAmounts["YYMI"] = 24500;
    this.baseIncomeAmounts["YYMO"] = 44900;
    this.baseIncomeAmounts["YYCO"] = 61200;
  }
}

export default IncomeCalculator;
